module.exports = __webpack_public_path__ + "img/he.7742fa61.png";